'use client';

import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function loading() {
  return (
    <div className="container">
      <div className=" h-19rem  flex justify-content-center	w-full align-items-center">
        <div>
          <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="3" fill="var(--surface-ground)" animationDuration=".5s" />
          <div>Loading...</div>
        </div>
      </div>
    </div>
  );
}
